export default {
  getStoreInfo: (state) => state.storeInfo,
  getCart: (state) => state.cart,
  getOrderType: (state) => state.orderType,
  getCoupon: (state) => state.coupon,
  getTotalProductsPrice: (state) => state.totalProductsPrice,
  getDeliveryFee: (state) => state.deliveryFee,
  getDiscountAmount: (state) => state.discountAmount,
  getAddress: (state) => state.address,
  getAddressDetail: (state) => state.addressDetail,
  getLocation: (state) => {
    return {
      latitude: state.latitude,
      longitude: state.longitude
    };
  },
  getReservedDate: (state) => state.reservedDate,

  getBalance: (state) => state.balance,
  getEpayInfo: (state) => {
    return { orderNo: state.orderNo, orderManageNo: state.orderManageNo };
  },
  getAll: (state) => state,
  getInvalidStockList: ({ invalidStockList }) => invalidStockList
};
